<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Jobs') }}</h4>
        </div>
        <div class="btn-row">
          <div
            class="btn-group">
            <button
              type="button"
              class="btn"
              :class="job_type === 'all' ? 'btn-secondary' : 'btn-light'"
              @click="setJobType('all')">{{ $t('All') }}</button>
            <button
              type="button"
              class="btn"
              :class="job_type === 'mine' ? 'btn-secondary' : 'btn-light'"
              @click="setJobType('mine')">{{ $t('Mine') }}</button>
          </div>

          <button 
            v-if="permissions.includes('manage_jobs')"
            type="button" 
            class="btn btn-primary" 
            @click="showCreateModal()">
            + {{ $t('New job') }}
            </button>
        </div>
      </div>

    </div>

    <div class="vflex-row-1">
      
      <filterfy
        :models="filtersMap"
        :initFilters="filters"
        @changed="setFilters">
        
        <Paginaty
          :total="paginate.total"
          :pages="paginate.pages"
          :page="paginate.page"
          :creating="creating"
          :loading="loading"
          @changePage="setPage">
          
          <template slot="content">
            <table class="table table-hover">
              <thead class="table-thead-sticky">
                <tr>
                  <th-sort
                    field="date_close"
                    :value="sort"
                    @input="setSort">
                    {{ $t('Deadline') }}
                    </th-sort>
                  <th-sort
                    field="title"
                    :value="sort"
                    @input="setSort">
                    {{ $t('Title') }}
                    </th-sort>
                  <th-sort
                    field="company_id"
                    :value="sort"
                    @input="setSort">
                    {{ $t('Company') }}
                    </th-sort>
                  <th-sort
                    field="publicate"
                    :value="sort"
                    @input="setSort">
                    Status
                    </th-sort>
                  <th>
                    {{ $t('Pipeline') }}
                    </th>
                  <th-sort
                    field="owner_user_id"
                    :value="sort"
                    @input="setSort">
                    {{ $t('Team') }}
                    </th-sort>
                </tr>
              </thead>
              <tbody>
                <job-list-item
                  v-for="(job, index) in jobs"
                  :key="index"
                  :job="job">
                  </job-list-item>
              </tbody>
            </table>
          </template>

          <template
            slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>

      </filterfy>

      <job-form
        v-if="modal_select"
        :initJob="modal_select" 
        @hideModal="hideModal()" 
        @deleted="loadData(); hideModal()" 
        @saved="redirectToJob">
        </job-form>

    </div>

  </div>

</template>

<script>
import JobForm from '@/components/JobForm/JobForm'
import Filterfy from '@/components/Filterfy/Filterfy'
import PointStatus from '@/components/Parts/PointStatus'
import Deadline from '@/components/Parts/Deadline'
import ThSort from '@/components/Parts/ThSort'
import RelatedUser from '@/components/Parts/RelatedUser'
import JobListItem from './JobListItem'
import Paginaty from '@/components/Paginaty/Paginaty'
import FilterfyToQuery from '@/utils/FilterfyToQuery'

export default {
  name: 'JobList',
  components: {
    JobForm,
    Filterfy,
    Deadline,
    ThSort,
    PointStatus,
    RelatedUser,
    JobListItem,
    Paginaty
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false,
      job_type: 'all',
      filtersMap: [
        {
          'type': 'keyword',
          'label': this.$t('Title'),
          'target': 'title'
        },
        {
          'type': 'keyword',
          'label': this.$t('Hiring manager'),
          'target': 'hiring_manager_name'
        },
        {
          'type': 'list',
          'label': 'Status',
          'target': 'status',
          'resource': 'job_status'
        },
        {
          'type': 'list',
          'label': this.$t('Companies'),
          'target': 'company_id',
          'resource': 'companies'
        },
        {
          'type': 'list',
          'label': this.$t('Departaments'),
          'target': 'departament_id',
          'resource': 'departaments'
        },
        {
          'type': 'list',
          'label': 'Tags',
          'target': 'tags',
          'resource': 'job-tags'
        },
        {
          'type': 'list',
          'label': this.$t('Owner'),
          'target': 'owner_user_id',
          'resource': 'users'
        }
      ]
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    jobs () {
      return this.$store.getters.getJobs
    },
    paginate () {
      return this.$store.getters.getJobsPaginate
    },
    filters () {
      return this.$route.query
    },
    sort () {
      return this.$route.query.sort || '-created_at'
    },
    filterJobType () {
      if (this.job_type === 'mine') {
        return { team: this.$store.getters.getMe._id }
      }
      return {}
    }
  },
  metaInfo () {
    return {
      title: this.$t('Jobs')
    }
  },
  created () {
    if (!this.filters.status) {
      this.$changeUrlParam({status: ['open']})
    }
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        ...this.filterJobType,
        page: this.$route.query.page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectJobs', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.setPage(1)
        this.loading = this.creating = false
      })
    },
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    setFilters
    */
    setFilters (filters) {
      this.$changeUrlParam(filters)
      this.setPage(1)
    },
    setSort (sort) {
      this.$changeUrlParam({sort: sort})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    },
    /*
    jobType
    */
    setJobType (type) {
      this.job_type = type
      this.loadData()
    },
    /*
    redirectToJob
    */
    redirectToJob (job) {
      this.$router.push({path: '/job/' + job._id})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/JobList/JobList.vue